import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  conteudo: {
    padding: 16,
    paddingBottom: 48,
  },
  subtituloTela: {
    fontSize: 13,
    color: Colors.GrayPallete.grayTwo,
    marginTop: 4,
    marginBottom: 16,
  },
  spinner: {
    marginTop: 40,
  },
  secao: {
    marginBottom: 24,
  },
  secaoTitulo: {
    fontSize: 15,
    fontWeight: '700',
    color: Colors.GrayPallete.grayOne,
    marginBottom: 4,
  },
  secaoDescricao: {
    fontSize: 12,
    color: Colors.GrayPallete.grayTwo,
    marginBottom: 8,
  },
  card: {
    borderWidth: 1,
    borderColor: Colors.GrayPallete.lightgrayTwo,
    borderRadius: 8,
    padding: 12,
    marginTop: 8,
    backgroundColor: '#FFFFFF',
  },
  cardTopo: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardTitulo: {
    fontSize: 15,
    fontWeight: '600',
    color: Colors.GrayPallete.grayOne,
    flexShrink: 1,
  },
  cardLinha: {
    fontSize: 13,
    color: Colors.GrayPallete.grayTwo,
    marginTop: 4,
  },
  cardAviso: {
    fontSize: 13,
    color: Colors.OrangePallete.orange,
    marginTop: 8,
    fontWeight: '600',
  },
  cardAcao: {
    fontSize: 13,
    color: Colors.RedPallete.red,
    marginTop: 8,
    fontWeight: '600',
  },
  selo: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 12,
    marginLeft: 8,
  },
  seloAceito: {
    backgroundColor: '#E7F7EA',
  },
  seloNaoAceito: {
    backgroundColor: Colors.GrayPallete.lightgray,
  },
  seloTexto: {
    fontSize: 11,
    fontWeight: '700',
  },
  seloTextoAceito: {
    color: Colors.GreenPallete.greenOne,
  },
  seloTextoNaoAceito: {
    color: Colors.GrayPallete.grayTwo,
  },
  estadoVazio: {
    marginTop: 40,
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  estadoVazioTitulo: {
    fontSize: 15,
    fontWeight: '600',
    color: Colors.GrayPallete.grayOne,
    textAlign: 'center',
  },
  estadoVazioTexto: {
    fontSize: 13,
    color: Colors.GrayPallete.grayTwo,
    textAlign: 'center',
    marginTop: 8,
  },
  tentarNovamente: {
    fontSize: 14,
    fontWeight: '700',
    color: Colors.RedPallete.red,
    marginTop: 12,
  },
});
